import React from 'react'

import { useMetadata } from '@scoir/tracking'
import { difference, isUndefined, map, merge } from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { FIELDS } from 'common/metadata-constants'
import { useMetadataToTrackedEvent } from 'common/metadata-custom-hooks'
import { DOMAIN_TYPES, EVENT_TYPES } from 'common/track-event-constants'
import track from 'common/track-events'
import { actions as compareActions } from 'store/college-compare'

import { COMPARE_LIMIT, COMPARE_PAGE_URL } from './config'

export const DEFAULT_COMPONENT = () => null

export const WrappedComponent = ({ component: Component, ...rest }) => {
  const getFn = useMetadataToTrackedEvent(EVENT_TYPES.MANAGE_COMPARE)
  const [get] = useMetadata()
  return (
    <Component
      {...rest}
      limit={COMPARE_LIMIT}
      onUpdateCollegeCompare={(...args) => {
        const [colleges] = args
        const newList = map(colleges, 'scid')
        const currList = map(rest.colleges, 'scid')
        const data = get()
        const te = getFn()
        const event = {
          ...te,
          DomainType: DOMAIN_TYPES.COLLEGE_COMPARE,
          EventData: {
            ...te.EventData,
            list: map(colleges, 'scid'),
            added: difference(newList, currList),
            removed: difference(currList, newList),
          },
        }
        if (!isUndefined(data) && data[FIELDS.PAGE]) {
          event.EventSourceReferrer = data[FIELDS.PAGE]
        }
        track(merge({}, rest.eventTracking, event))
        return rest.onUpdateCollegeCompare(...args)
      }}
      onNavigateToCollegeCompare={() => {
        rest.history.push(COMPARE_PAGE_URL)
      }}
    />
  )
}

WrappedComponent.propTypes = {
  history: PropTypes.object.isRequired,
  colleges: PropTypes.array,
  onUpdateCollegeCompare: PropTypes.func.isRequired,
  eventTracking: PropTypes.object,
  component: PropTypes.func.isRequired,
}

WrappedComponent.defaultProps = {
  colleges: [],
  component: DEFAULT_COMPONENT,
}

export const ConnectedComponent = connect(
  (store) => ({
    colleges: store.collegeCompare,
  }),
  {
    onUpdateCollegeCompare: compareActions.updateCollegeCompare,
  },
)(WrappedComponent)

export const ComponentWithRouter = withRouter(ConnectedComponent)

export default (component) => {
  return (props) => (
    <ComponentWithRouter
      component={component}
      {...props}
    />
  )
}
